/** TRAMS INVOICE.INVOICENUMBER — stored in invoices.metadata.tramsInvoiceNumber. */
export function getTramsInvoiceNumberFromMetadata(
  metadata: unknown,
): string | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const value = (metadata as Record<string, unknown>).tramsInvoiceNumber;
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (trimmed === '') return null;
  return trimmed;
}

export function formatTramsInvoiceDisplayNumber(
  tramsInvoiceNumber: string | number | null | undefined,
): string {
  if (tramsInvoiceNumber == null || tramsInvoiceNumber === '') return '—';
  return String(tramsInvoiceNumber);
}

/** TRAMS confirmation number column limit (shared by client validation and server schema). */
export const TRAMS_CONFIRMATION_NUMBER_MAX_LENGTH = 40;
